import { alpha } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default (theme: any) =>
  createStyles({

    rootContainer: {
      display: 'flex',
      flexFlow: 'column',
      width: '100%',
      alignItems: 'center',
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
      padding: 30,
      '& *': {
        fontFamily: 'Roboto !important',
      }
    },
    content: {
      width: '100%',
      borderRadius: 16,
      background: theme.gradiants.control,
      height: '100%',
      overflow: 'hidden',
    },
    headerStyle: {
      width: '100%',
      height: 65,
      display: 'flex',
      padding: '20px',
      justifyContent: 'center', // centered title
      alignItems: 'center',
      position: 'relative',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    bigIconBtnStyle: {
      width: 40,
      height: 40,
      borderRadius: 6,
      padding: 0,
      position: "absolute",
      right: 20,
      top: 10
    },
    headerTitle: {
      color: '#fff',
      fontSize: 26,
      fontWeight: 400,
    },

    scheduleInfoContainer: {
      width: '100%',
      height: 'calc(100% - 65px)',

      padding: '16px 20px 16px 20px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    mainContent: {
      width: 364,
      overflowY: 'auto',
      paddingRight: '3px',
    },

    fieldContainerStyle: { width: '100%' },
    inputStyle: {
      fontSize: '18px',
      color: 'rgb(255,255,255)',
    },
    iconStyle: { fontSize: '22px', color: 'white' },

    errorLabelStyle: {
      color: '#D32F2F',
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginTop: '10px',
      marginBottom: '10px',
      minHeight: '15px',
    },
    dividerStyle: { marginBottom: '5px', marginTop: '5px' },
    daysRow: {
      height: 'auto !important',
      flexDirection: 'column',
      alignItems: 'flex-start !important',
      justifyContent: 'space-between',
      padding: '0 !important',
      background: 'transparent !important',
      margin: 0,
      marginBottom: '4px !important',
    },
    daysContainer: {
      padding: '0px 0px',
      margin: '0px 0px',
      justifyContent: 'space-between',
      display: 'block',
    },
    dayLabelStyle: {
      color: 'white',
      backgroundColor: alpha('rgb(255,255,255)', 0.1),
      width: '12%',
      fontSize: '14px',
      textTransform: 'none',
      padding: '0px 0px',
      margin: '5px 0px',
      '& :hover': {
        backgroundColor: `${alpha('rgb(255,255,255)', 0.1)} !important`,
        color: 'rgb(255,255,255)',
      },
    },
    highlited: {
      background: theme.palette.secondary.main,
      color: 'rgb(255,255,255)',
      '&:hover': {
        background: theme.palette.secondary.main,
        color: 'rgb(255,255,255)',
      },
    },
    inputsContainer: {
      display: 'flex',
      flexFlow: 'row no-wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    controlArrowButton: {
      background: 'transparent !important',
      '&:disabled': {
        '& path': {
          opacity: 0.6,
        },
      },
    },
    hide: {
      display: 'none !important',
    },
    setpointStyle: {
      width: 'fit-content',
      minHeight: '30px',
      fontSize: '30px',
      fontWeight: 'normal',
      lineHeight: 'normal',
    },
    checkboxContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    setpointContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0 13px',
    },
    wideSetpointcontainer: {
      width: '210px',
    },
    fieldStyle: { width: '30px', '& input': { fontSize: '16px' } },

    valueTitle: {
      fontSize: '16px',
      color: 'rgb(255,255,255)',
      fontWeight: 'normal',
      lineHeight: 'normal',
      height: '100%',
      display: 'block',
    },
    startEndTimeContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 16px !important',
      height: '44px',
      marginBottom: '16px',
    },
    mainTimeContainer: {
      marginBottom: '16px !important',
    },

    timeContainer: {
      textTransform: 'none',
      height: '44px',
      width: '48%',
      color: '#fdfdfe',
      borderRadius: '22px',
      backgroundColor: alpha('rgb(255,255,255)', 0.1),
      fontSize: '16px',
      '&:hover': {
        backgroundColor: `${alpha('rgb(255,255,255)', 0.1)} !important`,
        color: 'rgb(255,255,255)',
      },
    },

    timePickerContainer: {
      height: 'auto !important',
      minHeight: 44,
    },
    timePickerContainerOpen: {
      paddingBottom: '10px !important',
    },

    statusStyle: {
      fontSize: '18px',
      fontHeight: 'normal',
      fontWeight: 'normal',
    },
    selectModeStyle: {
      color: '#fdfdfe',
      fontSize: '16px',
      lineHeight: '1',
      fontWeight: 'normal',
      width: '100%',
      wordWrap: 'break-word',
      minWidth: 0,
      padding: '10px 12px',
    },
    selectModeLabel: {
      padding: '2px 0',
      fontWeight: 400,
      fontSize: '16px',
      marginBottom: 8,
    },
    actionsLabel: {
      padding: '2px 8px',
      fontWeight: 400,
    },
    setPointSection: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    saveButton: {
      width: '100%',
      height: '100%',
      display: 'flex',
      minHeight: '60px',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    container: {
      width: '100%',
      color: 'rgb(255,255,255)',
      padding: '0 16px',
      borderRadius: '6px',
      background: alpha('#fdfdfe', 0.1),
      marginBottom: '8px',
      maxWidth: '768px',
      boxSizing: 'border-box',
      minHeight: 44,
      height: 44,
    },
    setPointContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },

    bodyRow: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 16,
      gap: 40,
      paddingTop: 10,
    },
    scheduleStatusStyle: {
      color: 'rgb(255,255,255)',
      fontSize: '18px',
    },
    controlSec: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: '100%',
    },
    powerOnPowerOffTimeIndication: {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
    checkboxStyle: {

    },
    selectModeContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      transition: 'height 0.15s ease-out',
    },
    tempSymbolStyle: { fontSize: '16px' },
    timeSelected: { border: `solid 1px ${theme.palette.secondary.main}` },
    iosTimeInput: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 10,
      visibilty: 'none',
      borderRadius: '22px',
      '& input': {
        background: 'blue',
        borderRadius: '22px',
        height: '100%',
        padding: 0,
        opacity: 0,
      },
    },
    iosTimeLabel: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 9,
      borderRadius: '22px',
      color: '#fdfdfe',
      fontSize: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    iosHourButton: {
      position: 'relative',
      display: 'flex',
      height: '44px',
      width: '48%',
      borderRadius: '22px',
      backgroundColor: alpha('rgb(255,255,255)', 0.1),
      boxShadow:
        '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    },
    redBtn: {
      width: '110px',
      height: '40px',
      minHeight: '40px',
      borderRadius: '6px',
      boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.1)',
      textTransform: 'none',
      backgroundColor: theme.palette.secondary.main,
      border: 0,
      '&:hover': {
        backgroundColor: alpha(theme.palette.secondary.main, 0.7),
        border: 0,
      },
      '&:focus': {
        backgroundColor: '#b3b3b3',
        border: 0,
      },
      '&:active': {
        backgroundColor: theme.palette.secondary.main,
        border: 0,
      },
      '&:disabled': {
        color: '#fdfdfe !important',
        opacity: 0.4,
        backgroundColor: `${theme.palette.secondary.main} !important`,
      },
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#ffffff',
    },
    backgroundContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      padding: '0 20px',
      height: '100%',
      backgroundImage: theme.gradiants.control,
      alignItems: 'flex-start',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(255,255,255,0.26)',
      },
    },

    inputClass: {
      height: 40,
      borderRadius: 4,
      '& input': {
        color: '#fdfdfe',
      },
      width: '100%',
      fontSize: '16px',
      color: '#fdfdfe',
      borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
      '& .MuiOutlinedInput-root': {
        height: 40,
        borderRadius: '6px',
      },
      '& input + fieldset': {
        borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
      },
      '& input:disabled + fieldset': {
        borderColor: `${'rgba(255, 255, 255, 0.3)'} !important`,
      },
      '& ::placeholder': {
        color: '#fdfdfe',
        opacity: 0.5,
        fontSize: '16px',
        lineHieght: 'normal',
        fontWeight: 'normal',
      },
      '& label': {
        color: `${'#fdfdfe'} !important`,
      },
      '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 16px) scale(1)',
      },
      '& .MuiOutlinedInput-input': {
        padding: '12px 14px',
        height: 40,
        boxSizing: 'border-box'
      },
    },
    tabRoot: {
      minHeight: '41px',
      width: '100%',
      borderBottom: '1px solid rgba(255,255,255,0.2)',
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    },
    tab: {
      opacity: 1,
      flex: 1,
      minHeight: 'unset',
      padding: '10px',
      textAlign: 'center',
      fontSize: '16px',
      fontWeight: 400,
      textTransform: 'capitalize',
      cursor: 'pointer',
      transition: 'all 0.2s',
      backgroundColor: alpha('#fff', 0.1),
      color: '#fff',
      height: 41,
      '&.Mui-selected': {
        backgroundColor: alpha('#fff', 0.2),
        borderBottom: '1px solid rgba(255,255,255,1)',
      },
    },
    weeklyTab: {
      borderTopLeftRadius: 4,
    },
    calendarTab: {
      borderTopRightRadius: 4,
    },
    tabContent: {
      background: alpha('#fff', 0.1),
      padding: '8px 12px',
      borderRadius: '0 0 4px 4px',
    },
    tabContainer: {
      width: '100%',
      color: 'rgb(255,255,255)',
      padding: '9px 10px 16px 10px !important',
      borderRadius: ' 0 0 6px 6px',
      background: alpha('#fdfdfe', 0.1),
      maxWidth: '768px',
      minHeight: 'max-content',
    },
    calendar: {
      fontFamily: 'Roboto',
      color: '#fff !important',
      width: '100%',
      '& .DayPicker-wrapper': {
        width: '100%',
      },
      '& .DayPicker-Month': {
        width: '100%',
        tableLayout: 'fixed',
      },
      '& .DayPicker-Day': {
        padding: '5% 0',
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      '& .DayPicker-Weekday': {
        color: '#fff',
        textAlign: 'center',
      },
      '& .DayPicker-Day--disabled': {
        color: alpha('#fdfdfe', 0.2),
      },
      '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)':
      {
        backgroundColor: theme.palette.secondary.main,
      },
      '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover':
      {
        backgroundColor: theme.palette.secondary.main,
      },
      '& .DayPicker:not(.DayPicker--interactionDisabled):hover': {
        backgroundColor: `${alpha('#fdfdfe', 0.1)} !important`,
      },
      '& .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover':
      {
        backgroundColor: `${alpha('#fdfdfe', 0.1)} !important`,
      },
    },
    collapse: {
      height: '0px',
    },
    curveTempIcon: {
      position: 'absolute',
      top: -13,
      left: 7,
      border: '1px solid #AAA',
      borderRadius: '50%',
      width: 15,
      height: 15,
      fontSize: 12,
    },
    curveTempOffIcon: {
      fontSize: 12,
      marginTop: 3,
    },
    ///
    setpointNotSet: {
      display: 'none !important',
    },
    enumContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '160px',
      justifyContent: 'space-between',
    },
    sensorValues: {
      fontFamily: 'Roboto',
      fontSize: 18,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#ffffff',
    },
    sensorValue: {
      fontFamily: 'Roboto',
      fontSize: 60,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#ffffff',
    },
    sensorValuesContainer: {
      position: 'absolute',
      top: '134px',
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      width: '200px',
      right: '38px',
    },
    measurementUnit: {
      fontFamily: 'Roboto',
      fontSize: 40,
      fontWeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: ' #ffffff',
      height: 80,
      lineHeight: '80px',
    },
    valueControl: {
      position: 'absolute',
      top: '50px',
      width: '270px',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: -1,
    },
    sensorSliderContainer: {
      marginTop: '-53px',
      maxWidth: '320px',
      maxHeight: '152px',
      zIndex: 1,
      position: 'relative',
    },
    hideHalfOfCircle: {
      position: 'absolute',
      top: '141px',
      width: '275px',
      height: '80px',
    },
    root: {
      width: '100%',
    },
    checkboxRowContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    actionsContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '8px',
    },

    cancelButton: {
      width: '110px',
      height: '40px',
      minHeight: '40px',
      borderRadius: '6px',
      border: '1px solid #8B808E',
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#ffffff',
    },

    missingMappingList: {
      listStyle: 'disc',
      paddingLeft: 20,
      margin: 0,
      textAlign: 'left',
      fontSize: 16,
      color: '#545964',
      lineHeight: 1.4,
      '& li + li': {
        marginTop: 8,
      },
    },
    missingMappingBold: {
      fontWeight: 600,
    },
  });
